import {fragments} from '@/gql';
import gql from 'graphql-tag';
export default gql`
  query CallsheetAnalyses($id: Value, $limit: Int) {
    CallsheetAnalyses(value: $id, valueKey: "callsheetID", limit: $limit) {
      ...callsheetAnalysisDetail
    }
  }
  ${fragments.callsheetAnalysisDetail}
  ${fragments.kgraphDetail}
  ${fragments.personDetail}
  ${fragments.companyDetail}
  ${fragments.companyNames}
  ${fragments.companyNameDetail}
  ${fragments.contactDetail}
  ${fragments.profession}
  ${fragments.companyDepartmentDetail}
  ${fragments.companyTypeTree}
  ${fragments.companyType}
  ${fragments.personArtworks}
  ${fragments.artworkDetails}
  ${fragments.artworkToArtifacts}
`;
